import script from "./DropList.vue?vue&type=script&setup=true&lang=js"
export * from "./DropList.vue?vue&type=script&setup=true&lang=js"

import "./DropList.vue?vue&type=style&index=0&id=0ac44673&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0ac44673"]])

export default __exports__